"use client";

import { ParallaxLayer } from "./ParallaxLayer";

interface IParallaxOrbProps {
  /** Positioning classes (absolute inset offsets) applied to the orb wrapper. */
  className?: string;
  /** Parallax speed (see ParallaxLayer). */
  speed?: number;
  /** CSS colour of the orb glow, e.g. "var(--color-mint-leaf-400)". */
  tint: string;
  /** Glow opacity as a percentage mixed into transparent (design uses 34–52). */
  strength?: number;
  /** Diameter in pixels. */
  size?: number;
}

/**
 * Decorative blurred radial-gradient orb that drifts on scroll.
 * Mirrors the layered background orbs from the redesign handoff.
 */
export function ParallaxOrb({
  className,
  speed = 0,
  tint,
  strength = 42,
  size = 560,
}: IParallaxOrbProps): React.ReactElement {
  return (
    <ParallaxLayer
      speed={speed}
      ariaHidden
      className={`pointer-events-none absolute rounded-full will-change-transform ${className ?? ""}`}
      style={{
        height: size,
        width: size,
        filter: "blur(70px)",
        backgroundImage: `radial-gradient(circle at center, color-mix(in srgb, ${tint} ${strength}%, transparent) 0%, transparent 62%)`,
      }}
    >
      <span className="sr-only" aria-hidden="true" />
    </ParallaxLayer>
  );
}
